export const GET_IMPORTANT_PLAN_INFO = 'GET_IMPORTANT_PLAN_INFO';
export const UPDATE_IMPORTANT_PLAN_INFO_SUCCESS = 'UPDATE_IMPORTANT_PLAN_INFO_SUCCESS';